import toast from "react-hot-toast";
import { privateRequest } from "../axios";

const ENDPOINT = {
    Email_TEMPLATE : "/email-template",
};

export const fetchEmail = async (
    pageNo: number = 1,
    perPage: number = 10,
    search: string = ""
) => {
    try {
        const response = await privateRequest.get(
            `${ENDPOINT.Email_TEMPLATE}?pageNo=${pageNo}&perPage=${perPage}&search=${search}`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error fetching Emails:', error);
        throw error;
    }
};


export const fetchEmailById = async (id: string) => {
    try {
        const response = await privateRequest.get(
            `${ENDPOINT.Email_TEMPLATE}/${id}`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        console.log("response", response.data);
        
        return response.data;
    } catch (error) {
        console.error('Error fetching Email by ID:', error);
        throw error;
    }
};

export const createEmail = async (data: any) => {
    try {
        const response = await privateRequest.post(
            ENDPOINT.Email_TEMPLATE,
            data
        );

        return response.data;
    } catch (error) {
        console.error('Error creating Email:', error);
        throw error;
    }
};

export const updateEmail = async (data: any,id:number) => {
    try {
        const response = await privateRequest.put(
            `${ENDPOINT.Email_TEMPLATE}/${id}`,
            data,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error: any) {
        console.error("Error updating Email:", error?.response || error);
        throw error;
    }
};

export const deleteEmailBYId = async (id: string) => {
    try {
        const response = await privateRequest.delete(
            `${ENDPOINT.Email_TEMPLATE}/${id}`
        );

        toast.success(response?.data?.message || "Email deleted successfully");
        console.log(response.data);
        

        return response.data;
    } catch (error) {
        toast.error(error?.message || "Failed to delete Email");
        console.error('Error deleting Email:', error);
        throw error;
    }
};